import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'admin/routes/router';
import { makeRandomString, moreInfoProps } from 'common/utils/utils.js'
import {
   fetchStories,
   getFilterBy,
   getNewStories,
   getImageEvent,
   deleteStory,
   getStory,
   deleteStoryImage,
   shareNewPost,
   uploadPosterImageOperation,
   uploadCompleteOperations,
   pinStoryOperations,
   updateStoryOperation,
} from 'admin/state/modules/stories/operations';
import { checkAndUnlockDemoPublicSiteOperation, loginAsOperation, siteDetailsRefreshOperation } from 'admin/state/modules/common/operations';
import {
   storiesDataSelector,
   isStoriesDataFetching,
   emptyDataSelector,
   isNewFetching,
   isFetchingFilterSelector,
   emptyDataByFilterSelector,
   activeStorySelector,
   isFetchingStorySelector,
   isPublishedSelector,
   isFetchingDeleteSelector,
   customPosterImageSelector,
   imageStorySelector,
   shareErrorsData,
   videoInitStorySelector,
} from 'admin/state/modules/stories/selectors';
import {
   uploadPosterImageStart,
   uploadPosterImageFailed,
   uploadPosterImageCompleted,
   updatePostCompleted,
   // shareNewPostCompleted,
   reorderStories,
} from 'admin/state/modules/stories/actions';
import {
   statisticsDataSelector,
   isStatisticsFetching,
} from 'admin/state/modules/members/selectors';
import { fetchStatisticsData } from 'admin/state/modules/members/operations'
import { contentMetaInfoSelector, siteInfoSelector } from 'admin/state/modules/common/selectors';
import PageLoader from 'common/components/modules/page-loading';
import AllStories from 'admin/views/stories/index/all-stories';
import EmptyState from 'common/components/modules/empty-states';
import PullRefresh from 'admin/utils/PullRefresh.js';
import Modal from 'common/components/modules/modal';
import AddNewStory from 'admin/views/add-new-story';
import ModalUrlHelper from 'common/utils/ModalUrlHelper.js';
import QueryParams from 'admin/utils/QueryParams.js'
import toster from 'common/utils/toast';
import PullToRefresh from 'pulltorefreshjs';
import toast from 'common/utils/toast';
import { push } from "connected-react-router";
import VideoUpload from 'admin/views/stories/video-story-upload/video-upload';
import * as api from 'admin/api/AuthApi.js';
import axios from 'axios'; import randomstring from 'randomstring';
import CreateStory from 'admin/views/stories/create-story';
import DeleteModal from 'admin/views/stories/modalDelete'
import { screenWidthSelector } from 'admin/state/modules/common/selectors';
// import { CopyContentLink } from 'admin/utils/CopyContentLink';
import { isMobileAndTablet } from 'common/utils/utils';
import TippersModal from 'admin/views/tips/tippers-details-modal'
import { getContentTipHistoryById, changeContentOrders } from 'admin/api/AuthApi';
import {
   countesStateSelector,
} from 'admin/state/modules/resources/selectors';
import { fetchMediaCountsStateOperation } from 'admin/state/modules/resources/operations';
import { arrayMoveImmutable } from 'array-move';
import './style.scss'
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import { contentMetaInfo, setShareModalAction } from 'admin/state/modules/common/actions';
import { history } from 'admin/state/store';
import DiscardChangeMethodModal from 'admin/views/media-modules/discard-change';
import { isEqual } from 'lodash';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_STORIES } from 'common/utils/intercom-articles';
import StoriesConfirmDialogs from 'admin/views/stories/confirm-dialogs';
import SfwWarningModal from 'admin/views/media-modules/SFW-warning-modal';
import CropImageModal from 'common/components/modules/crop-image-modal';
import cx from 'classnames'

class StoriesContainer extends Component {
   static propTypes = {
      data: PropTypes.object,
      isFetching: PropTypes.bool,
      fetchData: PropTypes.func,
      getFilterBy: PropTypes.func,
      getNewStories: PropTypes.func,
      isEmpty: PropTypes.bool,
      isNewFetching: PropTypes.bool,
      isEmptyByFilter: PropTypes.bool,
      isFetchingByFilter: PropTypes.bool,
      getImageEvent: PropTypes.func,
      deleteStory: PropTypes.func,
      deleteStoryImage: PropTypes.func,
      getStoryById: PropTypes.func,
      activeStory: PropTypes.object,
      isFetchingStory: PropTypes.bool,
      isFetchingDelete: PropTypes.bool,
      goTo: PropTypes.func,
      siteInfo: PropTypes.object,
      refreshSiteDetails: PropTypes.func,
      memberStatisticsData: PropTypes.func,
      // newPostShare: PropTypes.func,
      updatePost: PropTypes.func,
      uploadCompleteOperations: PropTypes.func,
      customPosterImage: PropTypes.object,
      videoInit: PropTypes.object,
      statisticsData: PropTypes.object,
      uploadPosterImageStart: PropTypes.func,
      uploadPosterImageFailed: PropTypes.func,
      uploadPosterImage: PropTypes.func,
      screenWidth: PropTypes.number,
      pinStory: PropTypes.func,
      fetchCountsState: PropTypes.func,
      countesState: PropTypes.object,
      reorderStories: PropTypes.func,
      contentMetaInfo: PropTypes.object,
      updateContentMetaInfo: PropTypes.func,
      loginAs: PropTypes.func,
      checkAndUnlockDemoPublicSite: PropTypes.func,
      updateStory: PropTypes.func,
      setShareModal: PropTypes.func,
      onSelectItem: PropTypes.func,
      isInsideModal: PropTypes.bool,
      selections: PropTypes.array,
   };

   constructor(props) {
      super(props);

      this.state = {
         onCloseOptionModal: true,
         addNewStoryState: false,
         isUploadVideoState: false,
         uploadingProgress: 0,
         compressionStatus: 'none',
         confirmationDialog: false,
         video: {},
         isCompleted: false,
         id: null,
         isNewVideoUpload: false,
         step: 'edit-story',
         hideStoryValue: false,
         description: '',
         uploadersArr: [],
         storyType: 'video',
         accessTypes: ['active'],
         errors: {},
         headerTitle: 'New story',
         openDeleteModal: false,
         deletedId: null,
         oldPosterImage: {},
         videoID: null,
         isButtonDisable: false,
         showDiscardChangesModal: false,
         isEdit: false,
         isOldPoster: false,
         commentPermission: 'public_guests_and_expired_members_cannot_read_or_write',
         isTippersModalOpen: false,
         contentId: null,
         storyDataWithTips: null,
         isClickedClose: false,
         isReorderMode: history.location.pathname === '/stories/reorder',
         confirmModal: {
            isOpen: false,
         },
         reorderedData: {
            newData: [],
            newIndex: null,
         },
         is_sfw: false,
         custom_thumbnail_is_sfw: false,
         is_custom_thumbnail: false,
         pinnedCount: {},
         confirmDialogs: {
            isOpen: false,
            type: null,
         },
         isOpenCheckSfwSettingsModal: false,
         showCropper: false,
         cropperFile: null,
         coverSrc: null,
      };
      this.storyPaths = [];
      this.CancelToken = axios.CancelToken;
      this.source = this.CancelToken.source();
      this.fillter = {
         count: 20,
         page: 1,
         ...QueryParams.getFilters(),
      };
      this.height = window.innerHeight;
      this.timeout = null;
      this.videoTimeout = null;
      this.uploadControllers = []
      this.initialData = {
         commentPermission: 'public_guests_and_expired_members_cannot_read_or_write',
         description: '',
         src: null,
         thumbnail: null,
         is_sfw: false,
         custom_thumbnail_is_sfw: false,
         is_custom_thumbnail: false,
      };
   }

   componentDidMount() {
      const {
         fetchData,
         getFilterBy,
         memberStatisticsData,
         fetchCountsState,
         isInsideModal,
      } = this.props;

      this.setState({
         uploadingProgress: 0,
      });

      const query = this.generateQuery()

      fetchCountsState(query);
      if(isInsideModal){
         let element = document.querySelector('#select-from-stories')
         if(element) element.addEventListener('scroll', this.handleScroll);
      } else {
         window.addEventListener('scroll', this.handleScroll);
      }
      window.addEventListener('popstate', this.onPropsState);
      PullToRefresh.init({
         ...PullRefresh.init(),
         onRefresh: (done) => {
            this.fillter = { ...this.fillter, page: 1 };
            const param = this.generateQuery()
            if(param){
               getFilterBy(param, this.state.isReorderMode)
               done();
            } else {
               getFilterBy([], this.state.isReorderMode)
               done();
            }
            window.isPullRefresh  = false
         },
      });

      fetchData(query, this.state.isReorderMode);
      memberStatisticsData();

      api.getPinnedCountStatistics('stories')
         .then(resp => {
            this.setState({
               pinnedCount: {
                  ...resp?.data,
               },
            })
         })
         .catch(err => console.log(err))

      if(window.location.search){
         ModalUrlHelper.triggerModal(this);
      }
      this.onRefreshStpes()
      const { video_id, type, edit_story } = QueryParams.getParsedSearchParams();
      if(edit_story){
         this.setState({ isEdit: true, id: edit_story, video_id: edit_story });
         QueryParams.deletQueryParam();
      }
      if(type === 'add'){
         this.setState({
            addNewStoryState: true,
         });
      }
      if(video_id){
         this.transcodeVideo(video_id);
         this.setState({
            uploadingProgress: 100,
            videoID: video_id,
         });
      }
      window.addEventListener('beforeunload', this.beforeUnloadAlertPopup);
   }


   componentWillUnmount() {
      const { isInsideModal } = this.props;
      window.isPullRefresh  = false
      PullRefresh.destroyAll();
      if(isInsideModal){
         let element = document.querySelector('#select-from-stories')
         if(element) element.removeEventListener('scroll', this.handleScroll);
      } else {
         window.removeEventListener('scroll', this.handleScroll);
      }
      if(this.timeout) {
         clearTimeout(this.timeout);
      }
      if(this.videoTimeout) {
         clearTimeout(this.videoTimeout)
      }
      window.removeEventListener('beforeunload', this.beforeUnloadAlertPopup);
   }
   beforeUnloadAlertPopup = (e) => {
      if(this.state.isCompleted && !this.onIsEqual()){
         e.preventDefault();
         e.returnValue = '';
      }
   };
   onPropsState = () => {
      ModalUrlHelper.resetAction();
   }

   generateDataForSimile = () => {
      let src = null;
      let thumbnail = null;
      if('video' === this.state.storyType){
         const { isOldPoster, oldPosterImage } = this.state;
         const { customPosterImage } = this.props;
         let poster = customPosterImage;
         if(isOldPoster){
            poster = oldPosterImage;
         }
         src = this.state?.video?.src || this.activeStory.src;
         thumbnail = poster.src;

      } else {
         src = []
         this.storyPaths.forEach(i => {
            src.push(i.src)
         })
      }
      const data = {
         commentPermission: this.state.commentPermission,
         description: this.state.description,
         src: src,
         thumbnail: thumbnail,
         is_sfw: this.state.is_sfw,
         custom_thumbnail_is_sfw: this.state.custom_thumbnail_is_sfw,
         is_custom_thumbnail: this.state.is_custom_thumbnail,
      }
      return data;
   }

   onIsEqual  = () => {
      const data = this.generateDataForSimile();
      // console.log(this.initialData, data, 'this.initialData, data')
      return isEqual(this.initialData, data);
   }

   handleScroll = (e) => {
      const { isInsideModal } = this.props;
      const { scrollHeight, clientHeight, scrollTop } = isInsideModal ? e.target : document.documentElement;

      if(((scrollHeight - scrollTop) - clientHeight < 100)) {
         this.nextPage()
      }
   }

   nextPage = async () => {
      const {
         getNewStories, isNewFetching, data: { current_page: currentPage, last_page: pages },
      } = this.props;
      let query = [];
      if(currentPage < pages && !isNewFetching) {
         this.fillter = { ...this.fillter, page: currentPage + 1 };
         query = this.generateQuery();
         await getNewStories(query, this.state.isReorderMode);
      } else {
         return
      }
   }

   onFilterChange = (queryName, checkedItem, type) => {
      const { getFilterBy, fetchCountsState, isInsideModal } = this.props;

      let key = type === 'sortBy' ? type : queryName

      this.fillter = {
         ...this.fillter,
         [key]: checkedItem,
         page: 1,
      }
      if(!isInsideModal){
         this.generateUrlQuery(this.fillter)
      }
      const param = this.generateQuery()
      getFilterBy(param, this.state.isReorderMode)
      fetchCountsState(param)
   };


   generateQuery = () => {
      const query = [];
      Object.keys(this.fillter).forEach((key) => {
         if(key){
            if(this.fillter[key]) {
               key !== 'count' && key !== 'page' && key !== 'sortBy' ? query.push(`query[]=${ key }=${ this.fillter[key] }`) : query.push(`${ key }=${ this.fillter[key] }`);
            }
         }
      });
      return query;
   };

   generateUrlQuery = (filter) => {
      if(filter) {
         const urlParams = {};
         Object.keys(filter).forEach((key) => {
            if(key){
               if(key !== 'count' && key !== 'page') {
                  urlParams[key] = filter[key]
               }
            }
         });
         QueryParams.defineFilters(urlParams)
      }
      let params = QueryParams.getFilters()

      // let emptyFilters = true

      // Object.keys(params).forEach(key => {
      //    if(key !== 'count' && key !== 'page' && params[key].length && params[key] !== 'date_added:desc') {
      //       emptyFilters = false
      //    }
      // })

      // this.setState({
      //    ...this.state,
      //    emptyFilters,
      // })

      this.filter = { count: 20, page: 1, ...params };

   };


   onImageChanges = (e) => {
      const { getImageEvent } = this.props;
      this.setState({
         addNewStoryState: true,
         isCompleted: true,
         storyType: 'image',
      });
      getImageEvent(e);

      // this.setState({
      //    cropperFile: e?.[0],
      //    showCropper: true,
      // })

      this.onFileChange(e, true);
   }

   onDeleteStory = async (id, imgIndex, isModal) => {
      const { data } = this.props;
      const { deleteStory, deleteStoryImage } = this.props
      const element = [...data.data].find(e => e.id === id)
      if(typeof imgIndex !== 'number') {
         await deleteStory(id);
         this.onRefreshStpes()

         const { data } = this.props;
         if(isModal){
            this.handleCloseModalByUrl()
         }
         if(data.data.length <= 1){
         }
      } else {
         if(element.src.length === 1){
            deleteStory(id)
            if(isModal){
               this.handleCloseModalByUrl()
            }
         } else {
            element.src.splice(imgIndex, 1)
            deleteStoryImage(id, imgIndex, element.src, isModal)
         }
      }
      this.setState({ onCloseOptionModal: true });
      this.handleCloseModalByUrl()
   }
   closeOptionModal = (val) => {
      this.setState({ onCloseOptionModal: val })
   }
   onVideoChange = (e) => {
      if(e){
         const file = e.target.files[0];

         const MAX_FILE_SIZE = 3 * 1024 * 1024 * 1024; // 3GB in bytes
         if(file.size > MAX_FILE_SIZE) {
            this.openCloseConfirmDialogs('video_upload_limit')
            return;
         }

         window.storyVideo = file;
         this.setState({ isUploadVideoState: true, storyType: 'video'  })
         this.uploadVideo(file)
      } else {
         const params = QueryParams.getParsedSearchParams();
         this.transcodeVideo(params.id);
      }
   }

   openAddModal = (val) => {
      const query = QueryParams.getParsedSearchParams()
      this.setState({
         addNewStoryState: val,
         isClickedClose: !val,
      }, () => {
         this.source = this.CancelToken.source()
         if(!this.state.addNewStoryState && query.type){
            QueryParams.deletQueryParam()
         }
      })
   }
   openUploadVideoModal = (val) => {
      this.setState({ isUploadVideoState: val })
   }
   getStoryById = async (id) => {
      const { getStoryById } = this.props
      await getStoryById(id)
   }

   handleCloseModalByUrl = () => {
      this.setState({ openModalByUrl: false }, () => {
         ModalUrlHelper.resetAction();
      })
   }
   openModalByUrl = ({ id, type }) => {
      this.setState(() => ({
         modalOpen: true,
         openModalByUrl: true,
         storyType: type,
      }), async () => {
         const { getStoryById } = this.props
         await  getStoryById(id)
         const modalParams = {
            id,
            type,
         };
         ModalUrlHelper.defineAction(modalParams);
      });
   };
   handleOpenFullScreen = (type, id) => {
      const { data } = this.props;
      const storiesData = [...data.data]
      this.activeStory = storiesData.find(elm => elm.id === id)
      this.setState(() => ({
         storyType: type,
         openModalByUrl: true,
      }), async () => {
         const { getStoryById } = this.props
         await getStoryById(id)
         const modalParams = {
            id,
            type,
         };
         ModalUrlHelper.defineAction(modalParams);
      });
   }
   onShareStory = (id, title) => {
      const { checkAndUnlockDemoPublicSite, setShareModal } = this.props;
      checkAndUnlockDemoPublicSite(() => {
         setShareModal({
            isOpen: true,
            additionalInfo: {
               contentType: 'story',
               contentId: id,
               contentTitle: title,
            },
         })
         // CopyContentLink(this.props.siteInfo.site_url, id, 'story');
      })
   }

   // video upload
   async uploadVideo(file) {
      const client = axios.create();
      const basename = randomstring.generate(32);
      const ext = file.name.split('.').pop();
      const filename = `${ basename }.${ ext }`;
      const s3PolicyGet = await api.getS3Policy();
      const s3Policy = s3PolicyGet.data;
      const key = `videos/${ filename }`;
      const formData = new FormData();
      formData.append('key', key);
      formData.append('AWSAccessKeyId', s3Policy.accesskey);
      formData.append('acl', 'private');
      formData.append('success_action_status', '201');
      formData.append('policy', s3Policy.policy);
      formData.append('signature', s3Policy.signature);
      formData.append('file', file);
      try {
         const { videoID } = this.state;
         if(!videoID) {
            await client.post(
               s3Policy.uploadUrl,
               formData,
               {
                  cancelToken: this.source.token,
                  headers: {
                     'Content-Type': 'multipart/form-data',
                  },
                  onUploadProgress: progress => {
                     const uploadingProgress = Math.floor(
                        (progress.loaded / progress.total) * 100
                     );
                     this.setState({
                        uploadingProgress,
                     });
                  },
               }
            );
         }
         const newData = {
            src: filename,
            type: 'video',
         }
         try {
            const storyResponse = await api.createStories(newData);
            const id = storyResponse.data.id;
            this.setState({ id: id });
            QueryParams.setQueryParam('video_id', id);
            this.transcodeVideo(id);
            this.setState({ videoID: id });
         } catch (err){

         }
      } catch (error) {
         //
      }
   }

   async transcodeVideo(id){
      const { uploadCompleteOperations } = this.props;
      let storyResponse = { data: { compressionStatus: '' } }
      if(id){
         storyResponse = await api.getStoryById(id);
      }
      const { data } = storyResponse;
      this.setState({ isCompleted: false, isUploadVideoState: true });
      this.setState({ compressionStatus: data.compression_status })
      if(data.compression_status === 'pending'){
         this.setState({ isCompleted: false, isUploadVideoState: true });
         await new Promise(resolve => {
            this.videoTimeout = setTimeout(resolve, 2000)
         });
         await this.transcodeVideo(data.id);
      } else if(data.compression_status === 'progress'){
         this.setState({ isCompleted: false, isUploadVideoState: true });
         await new Promise(resolve => {
            this.videoTimeout = setTimeout(resolve, 2000)
         });
         await this.transcodeVideo(data.id);
      } else if(data.compression_status === 'generating_poster_images'){
         this.setState({ isCompleted: false, isUploadVideoState: true });
         await new Promise(resolve => {
            this.videoTimeout = setTimeout(resolve, 2000)
         });
         await this.transcodeVideo(data.id);
      } else if(data.compression_status === 'completed'){
         var imagesKeysArray = Object.keys(data.full_system_generated_images);
         const length = imagesKeysArray?.length || 0;
         const randomIndex = Math.floor(Math.random() * length);
         const item = imagesKeysArray[randomIndex];
         const src = {
            full_src: data.full_system_generated_images[item],
            src: item,
            video_src: data.full_src,
         }
         await uploadCompleteOperations(id, src);
         this.setState({ video: data, isUploadVideoState: false })
         this.videoTimeout = setTimeout(() => {
            this.setState({ isCompleted: true })
         }, 100)
      }

   }

   // poster images
   updateVideo = async () => {
      const { customPosterImage } = this.props;
      const { id } = this.state;

      const src = { fullSrc: customPosterImage.full_src, video_src: customPosterImage.video_src };
      const data = {
         thumbnail: customPosterImage.src,
         type: 'video',
      }
      if(id){
         const newData = {
            id,
            full_thumbnail: src.fullSrc,
            video_src: src.video_src,
            ...data,
         }
         this.setState({ video: { ...this.state.video, ...newData } });
      }
   }

   onPosterImageChange = async (e) => {
      const { id, custom_thumbnail_is_sfw } = this.state;
      const {
         uploadPosterImageStart,
         uploadPosterImageFailed,
         uploadPosterImage,
         customPosterImage,
      } = this.props;
      if(!customPosterImage.warning) {
         this.setState({ oldPosterImage: customPosterImage });
      }
      this.setState({ isOldPoster: false })
      uploadPosterImageStart();
      const file = e.target.files[0];
      const type = file.name ? file.name.split('.') : '';
      const validFormat = ['jpeg', 'jpg', 'png', 'webp'];
      const isValid = validFormat.indexOf(type[type.length - 1].toLowerCase()) !== -1 && type.length > 1;
      if(isValid) {

         if(custom_thumbnail_is_sfw) {
            this.setState({
               custom_thumbnail_is_sfw: false,
            })
            this.setIsOpenCheckSfwSettingsModal(true)
         }

         const fileData = new FormData();
         fileData.append('file', file);
         await uploadPosterImage(fileData, id);
      } else {
         toast.error('Wrong image format');
         uploadPosterImageFailed()
      }
      this.setState({ isOldPoster: false, is_custom_thumbnail: true })
   }

   //////     Edit Story

   editStory = (id, type) => {
      QueryParams.setQueryParam('edit_story', '');
      QueryParams.deletQueryParam();
      const { data } = this.props;
      const storiesData = [...data.data]
      this.activeStory = storiesData.find(elm => elm.id === id);
      const {
         title,
         full_src,
         access,
         hide_after_minutes,
         full_thumbnail,
         thumbnail,
         src,
         comments_permission,
         is_sfw,
         custom_thumbnail_is_sfw,
         is_custom_thumbnail,
      } = this.activeStory;
      this.timeout = setTimeout(() => {
         this.initialData = {
            ...this.initialData,
            commentPermission: comments_permission,
            description: title,
            src: src,
            thumbnail,
            is_sfw,
            custom_thumbnail_is_sfw,
            is_custom_thumbnail,
         };
         this.setState(() => ({
            isCompleted: true,
            storyType: type,
            description: title,
            accessTypes: access,
            hideStoryValue: !!hide_after_minutes,
            headerTitle: 'Edit story',
            isEdit: true,
            isOldPoster: true,
            id,
            videoID: id,
            commentPermission: comments_permission,
            is_sfw,
            custom_thumbnail_is_sfw,
            is_custom_thumbnail,
         }), async () => {
            QueryParams.setQueryParam('edit_story', id);
         });
      }, 100);

      if(type === 'image') {
         const uploadersArr = full_src.map(function(path, index){
            let unicId = makeRandomString(10);
            return {
               id: unicId,
               loading: false,
               src: path,
               order: index + 1,
            }
         });
         this.storyPaths = src.map(function(path, index) {
            return {
               id: uploadersArr[index].id,
               src: path,
               order: index + 1,
            }
         });
         this.setState({
            uploadersArr,
         })

      } else {
         this.setState({
            oldPosterImage: {
               full_src: full_thumbnail,
               loading: false,
               src: thumbnail,
               video_src: full_src,
            },
         })
      }
   }

   onSortPhotosEnd = (data, oldIndex, newIndex) => {
      const orderedData = data.map((item, index) => {
         return {
            ...item,
            order: index + 1,
         };
      });
      const newData = arrayMoveImmutable(this.storyPaths, oldIndex, newIndex);
      this.setState({
         uploadersArr: orderedData,
      })
      this.storyPaths = newData;
   }

   //////////////// SHARE

   onFileChange = (e, init) =>  {
      const { is_sfw } = this.state;

      this.setState({
         errors: { ...this.state.errors,
            src: null,
         },
      });

      const targetFiles = init ? e : e.target.files;
      const filteredFiles = [];
      const newUploaders = [];
      const validMymeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

      Object.values(targetFiles).forEach(file => {
         if(validMymeTypes.includes(file.type)) {
            const id = makeRandomString(10);
            file.id = id;
            filteredFiles.push(file);
            newUploaders.push({
               id,
               loading: true,
               src: null,
            })
         }
      });

      if(newUploaders.length > 0) {
         this.setState((oldState) => {
            return  { uploadersArr: [...oldState.uploadersArr, ...newUploaders] }
         }, () => {

            if(is_sfw) {
               this.setState({
                  is_sfw: false,
               })
               this.setIsOpenCheckSfwSettingsModal(true)
            }

            filteredFiles.forEach((file) => {
               const data = new FormData();
               data.append('file', file);
               const controller = new AbortController();
               const signal = controller.signal;
               api.uploadStoryImage(data, { signal }).then((response) => {
                  const { data } = response;
                  const filename = data.path;

                  return api.getObjectUrl([filename], 'images/').then(response => {
                     const imageSrc = response.data[filename];
                     this.setState((oldState) => {
                        const newArr = oldState.uploadersArr.map((item, index) => {
                           if(file.id === item.id) {
                              return {
                                 ...item,
                                 src: imageSrc,
                                 loading: false,
                                 order: index + 1,
                                 filePath: data.path,
                              }
                           }
                           return item;
                        });

                        return (
                           { uploadersArr: newArr }
                        );
                     }, () => {
                        let newStoryPaths = []
                        this.state.uploadersArr.forEach((item) => {
                           const storyPathItem = this.storyPaths.find(el => el.id === item?.id)
                           if(storyPathItem) {
                              newStoryPaths.push(storyPathItem)
                           } else if(item && item.src && !item.loading) {
                              newStoryPaths.push({
                                 id: item.id,
                                 src: item.filePath,
                                 order: item.order,
                              })
                           }
                        })
                        this.storyPaths = newStoryPaths;

                        // Commented logic is changing sorting of "this.storyPaths", based on it building payload

                        // let order = null;
                        // let paths = this.storyPaths.map((path, index) => {
                        //    order = index + 1;
                        //    return {
                        //       ...path,
                        //    }
                        // });
                        // paths = [
                        //    ...paths,
                        //    {
                        //       id: file.id,
                        //       src: filename,
                        //       order: order + 1,
                        //    },
                        // ]
                        // this.storyPaths = paths;
                     });
                  });
               }).catch((error) => {
                  this.setState((oldState) => {
                     const newArr = oldState.uploadersArr.filter((item) => {
                        return file.id !== item.id
                     });
                     return { uploadersArr: newArr };
                  }, () => {
                     if(error.code !== 'ERR_CANCELED') {
                        toast.error('Error uploading image')
                     }
                  });
               });
               this.uploadControllers.push(controller)
            });
         });
      } else {
         toast.remove('Please select png or jpg image files')
      }
   }

   handleDeleteImage = (id) => {
      this.storyPaths = this.storyPaths.filter(item => item.id !== id);
      this.setState((oldState) => {
         return {
            uploadersArr: oldState.uploadersArr.filter((item) => {
               return item.id !== id
            }),
         }
      });
   }

   onHideStory = () => {
      this.setState(({ hideStoryValue }) => ({
         hideStoryValue: !hideStoryValue,
      }))
   };

   onChangePermission = commentPermission => {
      this.setState({
         commentPermission: commentPermission.value,
      })
   };

   onInputChange = (name, value) => {
      this.setState({
         [name]: value,
         errors: {
            ...this.state.errors,
            title: null,
            [name]: null,
         },
      })
   };

   onToggleFilter = (bool, item) => {
      const { accessTypes } = this.state
      let newFilter = [...accessTypes]
      if(bool) {
         newFilter = [...accessTypes, item]
      } else {
         newFilter = accessTypes.filter(value => value !== item)
      }
      if(0 !== newFilter.length) {
         this.setState({
            accessTypes: newFilter,
            errors: {
               ...this.state.errors,
               access: null,
            } })
      } else {
         toast.remove('This story must be available for stream for at least one group')
      }
   }


   constructCreateEditStoryPayload = (isEditStory) => {

      const {
         accessTypes,
         hideStoryValue,
         storyType,
         description,
         oldPosterImage,
         commentPermission,
         is_sfw,
         custom_thumbnail_is_sfw,
         is_custom_thumbnail,
      } = this.state;

      let payload;

      if('image' === storyType) {
         let src = []
         this.storyPaths.forEach(i => {
            src.push(i.src)
         })

         payload = {
            src: src,
            access: accessTypes,
            hide_after_minutes: hideStoryValue ? 24 * 60 : null,
            comments_permission: commentPermission,
            type: storyType,
            title: description,
            is_sfw,
            custom_thumbnail_is_sfw,
            is_custom_thumbnail,
         }

         if(isEditStory) {
            payload = {
               comments_permission: commentPermission,
               title: description,
               src: src,
               is_sfw,
               custom_thumbnail_is_sfw,
               is_custom_thumbnail,
            }
         }

      } else {
         const { isOldPoster } = this.state;
         const { customPosterImage } = this.props;

         let poster = customPosterImage;
         if(isOldPoster){
            poster = oldPosterImage;
         }

         payload = {
            ...this.state.video,
            access: accessTypes,
            hide_after_minutes: hideStoryValue ? 24 * 60 : null,
            comments_permission: commentPermission,
            title: description,
            full_thumbnail: poster.full_src,
            thumbnail: poster.src,
            is_sfw,
            custom_thumbnail_is_sfw,
            is_custom_thumbnail,
         }

         if(isEditStory) {
            payload = {
               comments_permission: commentPermission,
               title: description,
               thumbnail: poster.src,
               full_thumbnail: poster.full_src,
               is_sfw,
               custom_thumbnail_is_sfw,
               is_custom_thumbnail,
            }
         }

      }


      return payload;
   }

   onShare = async () => {
      const {
         fetchData,
         updateStory,
         updatePost,
         // newPostShare,
      } = this.props;
      const {
         videoID,
         id,
         accessTypes,
         storyType,
         is_sfw,
         custom_thumbnail_is_sfw,
         is_custom_thumbnail,
      } = this.state;
      const { edit_story } = QueryParams.getParsedSearchParams();
      const isEditStory = edit_story;
      this.setState({ addNewStoryState: false, isCompleted: true, isButtonDisable: true, isEdit: !!isEditStory });

      const payload = this.constructCreateEditStoryPayload(isEditStory)

      // Success callback after create or edit story
      const successCallback = () => {
         let toastText;

         if('image' === storyType) {

            this.initialData = {
               commentPermission: this.state.commentPermission,
               description: this.state.description,
               src: payload.src,
               thumbnail: null,
               is_sfw: this.state.is_sfw,
               custom_thumbnail_is_sfw: this.state.custom_thumbnail_is_sfw,
               is_custom_thumbnail: this.state.is_custom_thumbnail,
            }

            if(isEditStory) {
               toastText = 'Story has been updated';
            } else {
               toastText = 'active' === accessTypes ? 'Story has been added!' : 'Your story has been posted!';
            }
         } else {

            this.initialData = {
               commentPermission: this.state.commentPermission,
               description: this.state.description,
               src: this.state?.video?.src || this.activeStory.src,
               thumbnail: payload.thumbnail,
               is_sfw,
               custom_thumbnail_is_sfw,
               is_custom_thumbnail,
            }

            updatePost({ videoID, fullSrc: payload.full_thumbnail, video_src: this.state.video.video_src });
            // newPostShare(payload);

            if(isEditStory) {
               toastText = 'Story has been updated';
            } else {
               toastText = 'active' === accessTypes ? 'Story has been added' : 'Story has been published';
            }
         }

         this.onCloseModal();
         this.setState({ isButtonDisable: false })

         if(toastText) {
            toster.info(toastText);
         }

         if(!isEditStory) {
            this.fillter = {
               ...this.fillter,
               page: 1,
            }
            const query = this.generateQuery()
            fetchData(query, this.state.isReorderMode);
            this.onRefreshStpes()
         }
      }

      // Error callback after create or edit story
      const errorCallback = (errorResponseData) => {
         this.setState({ errors: errorResponseData, isButtonDisable: false });
      }

      if(isEditStory) {

         const storyId = 'image' === storyType ? id : videoID
         updateStory(storyId, payload, successCallback, errorCallback)

      } else {
         // Create story
         try {
            if('image' === storyType) {
               await api.createStories(payload)
            } else {
               await api.updateStoryData(videoID, payload)
            }
            successCallback()

         } catch (err) {
            errorCallback(err?.response?.data)
         }
      }
   };

   openDeleteConfirmModal = (id, imgIndex, isModal) => {
      setTimeout(() => {
         this.setState({ openDeleteModal: isModal, deletedId: id })
      }, 100)
   }

   changeStep = async (step) => {
      if(step === 'edit-story') {
         this.setState({ step: 'access-setting', isCompleted: true, headerTitle: 'Access settings' });
      }
      await this.updateVideo();
   }

   setShowDiscardChangesModal = bool => {
      this.setState({
         showDiscardChangesModal: bool,
      })
   }

   onCloseModal = () => {
      if(!this.onIsEqual()){
         this.setShowDiscardChangesModal(true);
         return
      }
      this.storyPaths = [];
      this.uploadControllers.forEach(controller => controller.abort())
      this.uploadControllers = [];
      this.initialData = {
         commentPermission: 'public_guests_and_expired_members_cannot_read_or_write',
         description: '',
         src: null,
         thumbnail: null,
         is_sfw: false,
         custom_thumbnail_is_sfw: false,
         is_custom_thumbnail: false,
      };
      this.setState({
         isCompleted: false,
         addNewStoryState: false,
         step: 'edit-story',
         headerTitle: 'New story',
         uploadersArr: [],
         compressionStatus: 'none',
         errors: {},
         description: '',
         isNewVideoUpload: true,
         videoID: null,
         id: null,
         commentPermission: 'public_guests_and_expired_members_cannot_read_or_write',
         isEdit: false,
         isOldPoster: false,
         is_sfw: false,
         custom_thumbnail_is_sfw: false,
         is_custom_thumbnail: false,
      })
      QueryParams.setQueryParam('edit_story', null);
      QueryParams.deletQueryParam();
   }

   onContinueClick = () => {
      const { step } = this.state;
      this.setState({ isCompleted: false });
      switch (step) {
         case 'edit-story':
            this.changeStep(step);
            break;
         case 'access-setting':
            this.onShare();
            break;
         default:
      }
   }

   onRefreshStpes = () => {
      const { siteInfo: {
         site_status: siteStatus,
      }, refreshSiteDetails } = this.props
      if('live' === siteStatus) {
         return
      }
      if('live' !== siteStatus) {
         refreshSiteDetails();
      }
   }

   handleCloseModal = () => {
      this.onTipModalClose()
   }

   onTipModalClose = () => {
      this.setState((...state) => {
         return {
            state,
            isTippersModalOpen: !this.state.isTippersModalOpen,
         }
      })
   }
   onClickSetId = (id) => {
      this.setState((...state) => {
         return {
            state,
            contentId: id,
         }
      })
   }

   fetchContentTipsData = (id) => {
      // eslint-disable-next-line no-unused-vars
      let data = getContentTipHistoryById(id, 'stories').then(res => {
         this.setState((...state) => {
            return {
               state,
               storyDataWithTips: res.data,
            }
         })
      }).catch((err) => {
         this.setState((...state) => {
            return {
               state,
               storyDataWithTips: [],
            }
         })
      })
   }

   cleanTipsState = () => {
      this.setState((...state) => {
         return {
            state,
            storyDataWithTips: null,
         }
      })


   }

   handleCloseUploading = () => {
      clearTimeout(this.videoTimeout)
      this.source.cancel('Operation canceled by the user');
      this.setState({
         isUploadVideoState: false,
         videoID: null,
         isClickedClose: true,
         compressionStatus: 'none',
         id: null,
         uploadingProgress: 0,
      })
   }

   onSortEnd = async ({ newData, newIndex }, bool = false) => {
      // eslint-disable-next-line no-unused-vars
      const { reorderStories, contentMetaInfo: { dont_show_content_reorder_message_story } } = this.props
      try {
         // if(!bool && !dont_show_content_reorder_message_story) {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: true,
         //       },
         //       reorderedData: { newData, newIndex },
         //    })
         // } else {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: false,
         //       },
         //       reorderedData: { newData: [], newIndex: null },
         //    })
         //    let replace_prev_id = !!newData[newIndex - 1] ? newData[newIndex - 1].id : null
         //    let replaced_id = newData[newIndex].id
         //    let replace_next_id = !!newData[newIndex + 1] ? newData[newIndex + 1].id : null
         //    const { data } = await changeContentOrders('stories', { replaced_id, replace_next_id, replace_prev_id, dont_show_message_again: dont_show_content_reorder_message_story })

         //    newData.forEach((item, index) => {
         //       if(item.id === replaced_id) {
         //          newData[index].publish_date = data.slice(0, data.length - 1)
         //       }
         //    })

         //    reorderStories(newData)
         //    toast.success('Content has been reordered')
         // }

         const isSortByAsc = this.fillter?.sortBy === 'date_added:asc'

         const orderedData = newData.map((item, index) => {
            return {
               id: item.id,
               order: !isSortByAsc ? newData.length - index : index + 1,
               name: item?.name,
            };
         })

         this.setState({
            reorderedData: { newData, newIndex },
         })

         await changeContentOrders('stories', { data: orderedData })


         reorderStories(newData)
         toast.success('Content has been reordered')

      } catch (error) {
         console.log(error);
      }
   }

   onFilterForReorder = () => {
      const { goTo } = this.props
      let route = history.location.pathname === '/stories' ? 'STORIES_REORDER' : 'STORIES'
      goTo(Router.route(`${ route }`).getCompiledPath())
   }

   openCloseConfirmDialogs = (type = null) => {
      this.setState({
         confirmDialogs: {
            isOpen: Boolean(type),
            type,
         },
      })
   }

   setIsOpenCheckSfwSettingsModal = (bool) => {
      this.setState({
         isOpenCheckSfwSettingsModal: bool,
      })
   }

   render() {
      const {
         data,
         isFetching,
         isEmpty,
         isNewFetching,
         isEmptyByFilter,
         isFetchingByFilter,
         activeStory,
         isFetchingStory,
         isFetchingDelete,
         goTo,
         customPosterImage,
         videoInit,
         statisticsData,
         siteInfo: {
            site_status: siteStatus,
            can_add_content: allowAddContent,
            site_url: siteUrl,
         },
         screenWidth,
         pinStory,
         countesState,
         contentMetaInfo,
         updateContentMetaInfo,
         loginAs,
         isInsideModal,
         selections = [],
         onSelectItem,
      } = this.props;
      const {
         addNewStoryState,
         onCloseOptionModal,
         openModalByUrl,
         isUploadVideoState,
         uploadingProgress,
         compressionStatus,
         isCompleted,
         step,
         hideStoryValue,
         description,
         storyType,
         uploadersArr,
         accessTypes,
         headerTitle,
         deletedId,
         openDeleteModal,
         oldPosterImage,
         videoID,
         isButtonDisable,
         isEdit,
         isOldPoster,
         commentPermission,
         isTippersModalOpen,
         contentId,
         storyDataWithTips,
         isReorderMode,
         confirmModal,
         showDiscardChangesModal,
         is_sfw,
         custom_thumbnail_is_sfw,
         is_custom_thumbnail,
         pinnedCount,
         confirmDialogs,
         isOpenCheckSfwSettingsModal,
         showCropper,
         cropperFile,
         coverSrc,
      } = this.state;

      const isDemoMode = siteStatus === 'demo_mode'


      let currentPosterImage = { ...customPosterImage };
      if(isOldPoster) {
         currentPosterImage = { ...oldPosterImage }
      } else {
         if(customPosterImage.warning) {
            currentPosterImage = { ...oldPosterImage }
         }
      }

      if('image' !== storyType && !currentPosterImage.video_src) {
         currentPosterImage.video_src = this.state?.video?.src || this.activeStory?.full_src
      }

      const shareButtonText = 'live' === siteStatus ? 'Share with selected groups' : 'Add story';
      const isUploading = videoID && !!videoID;
      if(isFetching){
         return (
            <div
               className={ cx({
                  'flex items-center justify-center': true,
                  'empty-height': !isInsideModal,
                  'h-full': isInsideModal,
               }) }
            >
               <PageLoader
                  withLoader={ isInsideModal }
                  customStyle={ cx({
                     'flex flex-1 h-full': isInsideModal,
                  }) }
               />
            </div>
         )
      }
      return (
         <div
            className={ cx({
               'flex flex-col': true,
               'content-height': !isInsideModal,
               'h-full': isInsideModal,
            }) }
         >
            <div className='flex flex-col h-full '>
               {
                  !isEmpty ? (
                     <>
                        <AllStories
                           stories={ data && !isReorderMode ? data.data : data?.data?.filter(story => !story.is_pinned) }
                           addStory={ () => {} }
                           onSelectFilter={ this.onFilterChange }
                           onStoriesSearch={ this.onFilterChange }
                           deleteStory={ false }
                           isLastPage={ isNewFetching }
                           endList={ data.current_page === data.last_page && !isEmptyByFilter }
                           isLoading={ isFetchingByFilter }
                           isEmpty={ isEmptyByFilter }
                           onImageChanges={ (e) => this.onImageChanges(e) }
                           onDeleteStory={ (id, imgIndex, isModal) => {
                              this.openDeleteConfirmModal(id, imgIndex, isModal) } }
                           onVideoChange={ this.onVideoChange }
                           getStoryById={ this.getStoryById }
                           activeStory={ activeStory }
                           isLoadingStory={ isFetchingStory }
                           nextPage={ () => this.nextPage() }
                           addNewStoryState={ addNewStoryState }
                           onCloseOptionModal={ onCloseOptionModal }
                           closeOptionModal={ this.closeOptionModal }
                           openAddModal={ this.openAddModal }
                           isFetchingDelete={ isFetchingDelete }
                           handleCloseModalByUrl={ this.handleCloseModalByUrl }
                           handleOpenFullScreen={ this.handleOpenFullScreen }
                           openModalByUrl={ openModalByUrl }
                           onClickShare={ this.onShareStory }
                           onClickComment={ (id) => goTo(Router.route("STORIES_COMMENTS").getCompiledPath({ id })) }
                           onCommentsClick={ (id) => goTo(Router.route("STORIES_COMMENTS").getCompiledPath({ id })) }
                           screen={ screenWidth }
                           shareStory={ this.shareStory }
                           editStory={ this.editStory }
                           openDeleteConfirmModal={ this.openDeleteConfirmModal }
                           isUploading={ isUploading }
                           pinStory={ pinStory }
                           onClickOpenTips={ this.onTipModalClose }
                           onClickSetId={ (id) => {
                              this.fetchContentTipsData(id)
                              this.onClickSetId(id)
                           } }
                           allowAddContent={ allowAddContent }
                           countState={ isReorderMode ? { total: pinnedCount?.not_pinned_total } : countesState?.stories  }
                           isReorderMode={ isReorderMode }
                           setReorderMode={ () => {
                              this.onFilterForReorder()
                           } }
                           onSortEnd={ (data) => this.onSortEnd(data) }
                           onSimpleFilter={ this.onFilterChange }
                           filters={ this.fillter }
                           onClickPreview={ () => {
                              loginAs({ id: null, type: 'guest' }, siteUrl, 'stories')
                           } }
                           isDemoMode={ isDemoMode }
                           isInsideModal={ isInsideModal }
                           selections={ selections }
                           onSelectItem={ onSelectItem }
                        />
                     </>

                  ) : (
                     <Fragment>
                        <EmptyState
                           icon='stories'
                           noContentText='You don’t have any stories'
                           buttonText={ allowAddContent ? 'Add new stories' : null  }
                           className='empty-height select-none'
                           onAdd={ () => this.openAddModal(true) }
                           linkButtonIcon='attention-outline'
                           linkButtonText='More info on stories'
                           overrideLinkButtonProps={ {
                              ...moreInfoProps(),
                           } }
                           onLinkClick={ () => Intercom.showArticle(ARTICLE_ID_ON_STORIES) }
                           dontAddIntercomClassName
                        />
                        {
                           addNewStoryState && (
                              <Modal
                                 roundedModal='lg'
                                 contentBgColor='major-dark'
                                 contentPosition={ screenWidth > 700 ? 'center' : 'full-screen' }
                                 onClose={ () => this.openAddModal(false) }
                              >
                                 <AddNewStory
                                    onCloseAddNewStory={ () => this.openAddModal(false) }
                                    onImagesChange={ (e) => this.onImageChanges(e) }
                                    onVideoChange={  this.onVideoChange }
                                    isUploading={ isUploading }
                                    isDemoMode={ isDemoMode }
                                 />
                              </Modal>
                           )
                        }
                     </Fragment>
                  )
               }
               {
                  isCompleted && (
                     <div>
                        <CreateStory
                           onCloseModal={ this.onCloseModal }
                           onClickContinue={ isEdit ? this.onShare : this.onContinueClick }
                           step={ step }
                           headerTitle={ headerTitle }
                           customPosterImage={ currentPosterImage }
                           onPosterImageChange={ this.onPosterImageChange }
                           statisticsData={ statisticsData }
                           onToggleFilter={ this.onToggleFilter }
                           storyType={ storyType }
                           hideStoryValue={ hideStoryValue }
                           description={ description }
                           hideStory={ this.onHideStory }
                           onChangeText={ this.onInputChange }
                           sharePost={ this.onShare }
                           deleteImg={ this.handleDeleteImage }
                           onImageChange={ (e) => {
                              // this.setState({
                              //    cropperFile: e?.target?.files?.[0],
                              //    showCropper: true,
                              // })
                              this.onFileChange(e, false)
                           } }
                           filters={ accessTypes }
                           paths={ uploadersArr }
                           onVideoChange={ this.onVideoChange }
                           videoInit={ videoInit }
                           siteStatus={ siteStatus }
                           shareButtonText={ shareButtonText }
                           height={ this.height }
                           isButtonDisable={ isButtonDisable }
                           onSortPhotosEnd={ this.onSortPhotosEnd }
                           onChangePermission={ this.onChangePermission }
                           isEdit={ isEdit }
                           isShowHideAfter={ 'live' === siteStatus }
                           commentPermission={ commentPermission }
                           isMobile={ screenWidth < 700 }
                           isDemoMode={ isDemoMode }
                           storyIsSfw={ is_sfw }
                           videoStoryCustomThumbnailIsSfw={ custom_thumbnail_is_sfw }
                           isCustomThumbnail={ is_custom_thumbnail }
                        />
                     </div>
                  )
               }
               {
                  showDiscardChangesModal && (
                     <DiscardChangeMethodModal
                        action={ () => {
                           let src = null;
                           if('video' === this.state.storyType){
                              src = this.state?.video?.src
                           } else {
                              src = []
                              this.storyPaths.forEach(i => {
                                 src.push(i.src)
                              })
                           }
                           this.initialData = this.generateDataForSimile();
                           this.setShowDiscardChangesModal(false);
                           this.onCloseModal();
                        } }
                        onCloseModal={ () => {
                           this.setShowDiscardChangesModal(false);
                        } }
                     />
                  )
               }
               <div>
                  {
                     isUploadVideoState && (
                        <Modal
                           roundedModal='lg'
                           contentBgColor='major-dark'
                           contentPosition={ screenWidth > 700 ? 'center' : 'full-screen' }
                           onClose={ () => {} }
                        >
                           <VideoUpload
                              data={ {
                                 uploading: uploadingProgress,
                                 status: compressionStatus,
                                 desktopType: screenWidth > 700 ? 'desktop' : 'mobile',
                              } }
                              headerLeftIconAction={ () => {
                                 this.openAddModal(false)
                                 this.openUploadVideoModal(false)
                                 this.handleCloseUploading()
                              } }
                           />
                        </Modal>
                     )
                  }
               </div>
               {
                  openDeleteModal && (
                     <DeleteModal
                        onCloseModal={ () => this.openDeleteConfirmModal(null, false) }
                        deleteStory={ () => {
                           this.onDeleteStory(deletedId);
                           this.openDeleteConfirmModal(null, null, false)
                           if(data.data && data.data.length < 10){
                              this.nextPage();
                           }
                        } }
                        onClickCancel={ () => this.openDeleteConfirmModal(null, null, false) }
                        isMobile={ screenWidth < 701 }
                        isCloseAction
                     />
                  )
               }
               {
                  contentId && isTippersModalOpen && (
                     <Modal
                        fullScreenMode={ isMobileAndTablet() }
                        contentPosition='responsive'
                        onClose={ () => this.handleCloseModal() }
                        otherClassName='tipper sm:!rounded-xlg'
                     >
                        <TippersModal
                           onModalClose={ this.onTipModalClose }
                           content={ storyDataWithTips }
                           contentId={ contentId }
                           onTipsModalClose={ this.cleanTipsState }
                        />
                     </Modal>
                  )
               }
               {
                  confirmModal.isOpen &&
                  <ConfirmModal
                     title='Publication date change'
                     type='confirm'
                     icon='warning'
                     iconColor='warning'
                     description='Reordering has the effect of changing the publication date of content that is being reordered. Are you sure you want to reorder content?'
                     contentWidth='375px'
                     buttonText='Yes, I want to reorder content'
                     // buttonClassName='mt-6 !text-sm'
                     action={ () => this.onSortEnd({ newData: this.state.reorderedData.newData, newIndex: this.state.reorderedData.newIndex }, true) }
                     cancelButtonAction={ () => {
                        updateContentMetaInfo({
                           ...contentMetaInfo,
                           dont_show_content_reorder_message_story: false,
                        })
                        this.setState({
                           ...this.state,
                           confirmModal: {
                              isOpen: false,
                           },
                           reorderedData: {
                              newData: [],
                              newIndex: null,
                           },
                        })
                     } }
                     isPreventDeafault={ false }
                     isMobile={ screenWidth < 700 }
                  >
                     <div className='w-full mt-8 flex items-center justify-center'>
                        <CheckboxLabel
                           name='dont_show_message_again'
                           checked={ contentMetaInfo?.dont_show_content_reorder_message_story }
                           className='flex justify-center'
                           textColor='secondary'
                           label='Don’t show again'
                           onChange={ () => {
                              updateContentMetaInfo({
                                 ...contentMetaInfo,
                                 dont_show_content_reorder_message_story: !contentMetaInfo?.dont_show_content_reorder_message_story,
                              })
                           } }
                           padding='0'
                        />
                     </div>
                  </ConfirmModal >
               }
               {
                  confirmDialogs.isOpen && Boolean(confirmDialogs.type) && (
                     <StoriesConfirmDialogs
                        isMobile={ screenWidth <= 1024 }
                        type='video_upload_limit'
                        onCloseModal={ () => this.openCloseConfirmDialogs(null) }
                     />
                  )
               }
               {
                  isOpenCheckSfwSettingsModal && (
                     <SfwWarningModal
                        modalType='check_sfw_settings'
                        onConfirm={ () => this.setIsOpenCheckSfwSettingsModal(false) }
                        onCloseModal={ () => this.setIsOpenCheckSfwSettingsModal(false) }
                     />
                  )
               }
               {
                  showCropper && (
                     <CropImageModal
                        isMobile={ window?.innerWidth < 1025 }
                        onCloseModal={ () => this.setState({
                           showCropper: false,
                        }) }
                        initialFile={ cropperFile }
                        initialImageSrc={ coverSrc }
                        onSave={ (file) => {
                           this.onFileChange({
                              ...cropperFile,
                              target: {
                                 ...cropperFile?.target,
                                 files: { 0: file },
                              },
                           }, false)

                           this.setState({
                              showCropper: false,
                              coverSrc: null,
                           })
                        } }
                        callbackAfterFileRead={ () => {
                           this.setState({
                              cropperFile: null,
                           })
                        } }
                        aspectRatio={ 0 }
                        initialAspectRatio={ 16 / 9 }
                     />
                  )
               }
            </div>
         </div>
      )
   }
}

const mapStateToProps = state => ({
   data: storiesDataSelector(state),
   isFetching: isStoriesDataFetching(state),
   isEmpty: emptyDataSelector(state),
   isNewFetching: isNewFetching(state),
   isEmptyByFilter: emptyDataByFilterSelector(state),
   isFetchingByFilter: isFetchingFilterSelector(state),
   activeStory: activeStorySelector(state),
   isFetchingStory: isFetchingStorySelector(state),
   isPublished: isPublishedSelector(state),
   isFetchingDelete: isFetchingDeleteSelector(state),
   siteInfo: siteInfoSelector(state),
   customPosterImage: customPosterImageSelector(state),
   initImageData: imageStorySelector(state),
   videoInit: videoInitStorySelector(state),
   errors: shareErrorsData(state),
   statisticsData: statisticsDataSelector(state),
   statisticsFetching: isStatisticsFetching(state),
   screenWidth: screenWidthSelector(state),
   countesState: countesStateSelector(state),
   contentMetaInfo: contentMetaInfoSelector(state),
});

const mapDispatchToProps = dispatch => ({
   fetchData: (params, isReorderMode) => dispatch(fetchStories(params, isReorderMode)),
   getFilterBy: (params, isReorderMode) => dispatch(getFilterBy(params, isReorderMode)),
   getNewStories: (params, isReorderMode) => dispatch(getNewStories(params, isReorderMode)),
   getImageEvent: params => dispatch(getImageEvent(params)),
   deleteStory: id => dispatch(deleteStory(id, 'list')),
   getStoryById: id => dispatch(getStory(id)),
   deleteStoryImage: (id, index, src, isModal) => dispatch(deleteStoryImage(id, index, src, isModal)),
   goTo: (location) => {
      dispatch(push(location))
   },
   refreshSiteDetails: () => dispatch(siteDetailsRefreshOperation()),
   shareNewPost: data => dispatch(shareNewPost(data)),
   uploadPosterImage: (file, id) => dispatch(uploadPosterImageOperation(file, id)),
   uploadCompleteOperations: (id, data) => dispatch(uploadCompleteOperations(id, data)),
   uploadPosterImageStart: () => dispatch(uploadPosterImageStart()),
   uploadPosterImageFailed: () => dispatch(uploadPosterImageFailed()),
   uploadPosterImageCompleted: (src) => dispatch(uploadPosterImageCompleted(src)),
   memberStatisticsData: () => dispatch(fetchStatisticsData()),
   updatePost: (id, fullSrc, video_src) => dispatch(updatePostCompleted(id, fullSrc, video_src)),
   // newPostShare: (data) => dispatch(shareNewPostCompleted(data)),
   pinStory: (id, bool) => dispatch(pinStoryOperations(id, bool)),
   fetchCountsState: (query) => {
      dispatch(fetchMediaCountsStateOperation('stories', query));
   },
   reorderStories: (data) => dispatch(reorderStories(data)),
   updateContentMetaInfo: info => dispatch(contentMetaInfo(info)),
   loginAs: (data, url, pageUrl) => {
      dispatch(loginAsOperation(data, url, pageUrl));
   },
   checkAndUnlockDemoPublicSite: (callback) => dispatch(checkAndUnlockDemoPublicSiteOperation(callback)),
   updateStory: (id, payload, callback) => dispatch(updateStoryOperation(id, payload, callback)),
   setShareModal: (data) => dispatch(setShareModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoriesContainer);
